var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvalGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 12 12",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMS-Manager-v6",
    transform: "translate(-928.000000, -1687.000000)",
    fill: "#569177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(80.000000, 1385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(57.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 796,
    cy: 307,
    r: 5,
    vectorEffect: "non-scaling-stroke"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalGreen);
export default __webpack_public_path__ + "static/media/Oval-green.04cfd99086fa4045018f8391ca8adc4e.svg";
export { ForwardRef as ReactComponent };